export default __webpack_public_path__ + "static/media/bird_black_male.671060f4.png";